import React, {useEffect} from 'react';
import _ from 'lodash';
import div from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import PropTypes from 'prop-types';
import AgyleTextField from '../../../../../components/ui/fields/agyleTextField';
import clsx from 'clsx';
import {isSpecialSmallDeviceDetect} from '../../../../../util/isSpecialSmallDeviceDetect';
import {obsStyles} from '../obsStyle';

function ObsNumericStepper(props) {
    const classes = obsStyles();
    const [value, setValue] = React.useState(props.value);
    const [textValue, setTextValue] = React.useState(!_.isNull(value) ? value?.toFixed(props.precision) : '');
    const stepper = React.useRef(false);
    const isSmallDevice = isSpecialSmallDeviceDetect();

    useEffect(() => {
        updateValue(props.value);
    }, [props.value]);

    useEffect(() => {
        if (!props.device) updateValue(value);
    }, [props.precision, props.minValue, props.maxValue]);

    useEffect(() => {
        updateValue(props.value);
    }, [props.device]);

    const updateValue = (newValue) => {
        if (_.isString(newValue)) newValue = _.toNumber(newValue);

        if (!_.isNull(newValue)) {
            if (!_.isNaN(props.device) && newValue < props.minValue && !stepper.current) {
                if (props.device?.id === 'nonRebreatheMask') newValue = props.device.default;
            }
            if (!_.isNaN(props.minValue) && newValue < props.minValue) {
                newValue = props.minValue;
            }
            if (!_.isNaN(props.maxValue) && newValue > props.maxValue) {
                newValue = props.maxValue;
            }
        }

        setValue(newValue);
        setTextValue(!_.isNull(newValue) ? newValue.toFixed(props.precision) : '');
        stepper.current = false;
        if (props.onChange && value !== newValue) {
            props.onChange(newValue);
        }
    };

    const onValueChange = (event) => {
        const {value} = event.target;
        // console.log("ObsNumericStepper.onValueChange.value", event.target.value);
        // updateValue(event.target.value);
        if (!_.isNaN(_.toNumber(value))) {
            setTextValue(value);
        }
    };

    const onBlur = (event) => {
        const {value} = event.target;
        if (_.isString(value) && value === '') return;
        // console.log("ObsNumericStepper.onBlur.value", event.target.value);
        if (!_.isNaN(_.toNumber(value))) {
            updateValue(value);
        }
    };

    const doStep = (direction) => {
        stepper.current = true;
        const oldVal = _.isNull(value) ? -1 : value;
        // console.log("oldValue: ", value);
        let newValue;

        if (direction < 0) {
            newValue = (oldVal - props.step).toFixed(props.precision);
        } else {
            newValue = (oldVal + props.step).toFixed(props.precision);
        }

        updateValue(newValue);
    };

    return (
        <div className={clsx(classes.numericStepper, props.column && 'float', props.noBackground && 'noBackground')}>
            <div
                className={clsx(classes.numericStepperMain, classes.divRow)}
                style={{
                    flexDirection: (props.column || isSmallDevice) ? 'column' : 'row',
                }}
            >
                <div className={clsx(classes.numericStepperLabel, props.column && 'margin')}>
                    {props.label}
                </div>

                <div className={classes.divRow}>
                    <div>
                        <IconButton
                            aria-label="dec"
                            size="small"
                            disabled={props.disabled}
                            onClick={() => doStep(-1)}
                            className={classes.numericStepperIcon}
                        >
                            <RemoveIcon/>
                        </IconButton>
                    </div>

                    <div>
                        <AgyleTextField
                            className={classes.numericStepperTextField}
                            variant="outlined"
                            placeholder={'Value'}
                            InputProps={{
                                inputProps: {
                                    inputMode: 'decimal',
                                },
                            }}
                            noBorder={false}
                            disabled={props.disabled}
                            InputLabelProps={{shrink: true}}
                            inputProps={{
                                className: classes.numericStepperInput,
                                step: props.step,
                                inputMode: 'decimal',
                            }}
                            style={{
                                maxWidth: 75,
                            }}
                            required={props.required}
                            pattern="[0-9]*"
                            inputMode={'decimal'}
                            type="number"
                            value={textValue}
                            onChange={onValueChange}
                            onBlur={onBlur}
                            textAlign={'center'}
                        />
                    </div>

                    <div>
                        <IconButton
                            aria-label="inc"
                            size="medium"
                            disabled={props.disabled}
                            onClick={() => doStep(1)}
                            className={classes.numericStepperIcon}
                        >
                            <AddIcon/>
                        </IconButton>
                    </div>
                </div>
            </div>
        </div>
    );
}

ObsNumericStepper.propTypes = {
    label: PropTypes.string,
    required: PropTypes.bool,
    value: PropTypes.number,
    step: PropTypes.number,
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
    precision: PropTypes.number,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    column: PropTypes.bool,
    noBackground: PropTypes.bool,
};

ObsNumericStepper.defaultProps = {
    label: 'ObsNumericStepper',
    required: false,
    value: null,
    step: 1,
    precision: 0,
    disabled: false,
    column: false,
    noBackground: false,
};

export default React.memo(ObsNumericStepper);
